module.exports = __webpack_public_path__ + "img/play-store.f491f3eb.png";